import type { NodeTypes } from '@xyflow/react';
import { DeviceNodeView } from './DeviceNodeView';

export const nodeTypes = {
  ukrop: DeviceNodeView,
} satisfies NodeTypes;
